module.exports = __webpack_public_path__ + "img/ic-search.95d9c252.svg";